import Vue from 'vue'

export default Vue.observable({
    account: '',
    currentUser: null,
//    badge: 0,
    nowOffsetHours: 0,
	regions: [],
	currentRegion: ''
})